import { isValidPhoneNumber } from 'libphonenumber-js';
import * as yup from 'yup';

import { VenueNumberVariation } from './types';

export const phoneNumberValidation = (extension: string) => {
  return yup.string().test('Validate phone number', 'Must be a valid phone number', (value: string | undefined) => {
    if (value === undefined) {
      return true;
    }
    const phoneNumber = value || '';
    return isValidPhoneNumber(extension + phoneNumber);
  });
};

export const selfServeSignupValidationSchema = yup.object({
  language: yup.string().required(),
  country: yup.string().required(),
  firstName: yup.string().trim().required(),
  lastName: yup.string().trim().required(),
  name: yup.string().trim().required(),
  phoneNumber: yup
    .object({
      extension: yup.string().required(),
      number: yup
        .string()
        .trim()
        .required()
        .when('extension', (extension: string) => phoneNumberValidation(extension)),
    })
    .required(),
  email: yup.string().trim().email().required(),
  venues: yup
    .object({
      name: yup.string().trim().required(),
      address: yup.string().trim().required(),
      postCode: yup.string().trim().required(),
      city: yup.string().trim().required(),
      isWoltCity: yup.boolean().required(),
      venueNumber: yup.mixed<VenueNumberVariation>().oneOf(['one', 'multiple']).required(),
      otherCity: yup
        .string()
        .trim()
        .when('city', (city: string, schema: yup.StringSchema) => (city === 'other' ? schema.required() : schema))
        .defined(),
    })
    .required(),
  businessId: yup.string().trim().required(),
  businessType: yup.string().trim().required(),
});
